var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i-button',{attrs:{"slot":"top-buttons","size":"large","type":"primary"},on:{"click":_vm.add_media},slot:"top-buttons"},[_vm._v(" "+_vm._s(_vm.$t('pbx.media.list.add_media'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }